import { Purchase } from './custom-checkout-events.model';
import { CxEvent } from "@spartacus/core";

export class CustomOrderPlacedEvent extends CxEvent {
  /**
   * ecommerce
   */
  event: string;
  ecommerce: Purchase;
}
